<template>
  <el-select 
    v-model="selectedValue"
    :style="{width: width}"
    placeholder="请选择仓库"
    clearable
    filterable
  >
    <el-option
      v-for="item in warehouseList"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    />
  </el-select>
</template>

<script>
import requestTicket from '@/utils/requestTicket'

export default {
  name: 'WarehouseLov',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: String,
      default: '150px'
    }
  },
  data() {
    return {
      warehouseList: [],
      selectedValue: this.value
    }
  },
  watch: {
    selectedValue(newVal) {
      // 返回选中对象的完整信息（包含id和name）
      this.$emit('callBack', this.warehouseList?.find(item => item.id === newVal))
    },
    value(newVal) {
      this.selectedValue = newVal
    }
  },
  mounted() {
    this.fetchWarehouseList()
  },
  methods: {
    async fetchWarehouseList() {
      try {
        const res = await requestTicket.post('/Ticketing/warehouse/findAll')
        this.warehouseList = res.data || []
      } catch (error) {
        console.error('获取仓库列表失败:', error)
      }
    }
  }
}
</script>